import { jsxs, jsx } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils/common';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { SelectSlot } from '../../../shared/components/slot/Slot.mjs';
import { searchFieldRoot, searchFieldRootVariants, searchFieldInput } from '../../../shared/styles/searchField.vanilla.mjs';
import { SelectSearchFieldClearIconButton as SingleSelectSearchFieldClearIconButton } from '../search-field-clear-icon-button/SearchFieldClearIconButton.mjs';
import { SelectSearch as SingleSelectSearch } from '../search/Search.mjs';

const SingleSelectSearchField = forwardRef(
  ({
    className: classNameFromProps,
    state,
    variant,
    leftSlot,
    rightSlot,
    ...props
  }, forwardedRef) => {
    const searchFieldClassName = classNames(
      searchFieldRoot({ disabled: props.disabled }),
      searchFieldRootVariants({ state, variant })
    );
    const searchFieldInputClassName = classNames(
      searchFieldInput,
      classNameFromProps
    );
    return /* @__PURE__ */ jsxs("label", { className: searchFieldClassName, children: [
      /* @__PURE__ */ jsx(
        SelectSlot,
        {
          "data-scope": "single-select",
          "data-part": "search-field-left-slot",
          children: leftSlot
        }
      ),
      /* @__PURE__ */ jsx(
        SingleSelectSearch,
        {
          className: searchFieldInputClassName,
          ref: forwardedRef,
          ...props
        }
      ),
      /* @__PURE__ */ jsx(
        SelectSlot,
        {
          "data-scope": "single-select",
          "data-part": "search-field-right-slot",
          children: isNil(rightSlot) ? /* @__PURE__ */ jsx(SingleSelectSearchFieldClearIconButton, {}) : rightSlot
        }
      )
    ] });
  }
);

export { SingleSelectSearchField as SelectSearchField };
//# sourceMappingURL=SearchField.mjs.map
